import React from "react";
import styles from "./History.module.scss";
import PageTemplate from "../../templates/PageTemplate";
import Container from "../../templates/Container";
import Head from "../../elements/Head/Head";

import { ReactComponent as VenzelFive } from "../../../assets/svg/venzel_5_2color.svg";
import { useSelector } from "react-redux";

const History = () => {
  const colorThemeRedux = useSelector((state) => state.theme.colorTheme);

  return (
    <>
      <PageTemplate>
        <Head />

        <Container>
          <section className={styles.history}>
            <h1
              className={styles.title}
              style={colorThemeRedux ? { fontSize: 30, color: "#000" } : {}}
            >
              История фестиваля
            </h1>
            {!colorThemeRedux && <div className={styles.separator} />}

            <div
              className={
                styles.frame +
                " " +
                (colorThemeRedux ? styles.lowVisibleVersion : "")
              }
            >
              <div className={styles.content}>
                <p>
                  С 12 по 21 июня 2023 года в Красноярском крае, географическом
                  центре России, во второй раз состоится знаменательное событие,
                  направленное на возрождение традиционной национальной
                  культуры, – Фестиваль мужских хоров.
                </p>
                <p>
                  В рамках Фестиваля выступили прославленные мужские хоры из
                  Белграда, Воронежа, Грозного, Калуги, Красноярска, Минска,
                  Москвы, Петрозаводска, Самары, Санкт-Петербурга, Саратова и
                  Симферополя.
                </p>
                <p>
                  В концертных программах Фестиваля примут участие прославленные
                  мужские и детско-юношеские хоры из зарубежья – Республики
                  Армения, Республики Беларусь, Грузии, Республики Сербия и
                  Российской Федерации – Воронежской области, Красноярского
                  края, Московской области, Республики Крым, Республики Северная
                  Осетия – Алания, Санкт-Петербурга, Свердловской области,
                  Тверской области, Чеченской Республики.
                </p>
                <p>
                  Во время Фестиваля пройдут 40 мероприятий, которые посетят
                  более 15 000 человек, в том числе 20 концертных программ будут
                  представлены в муниципальных образованиях Красноярского края:
                  Ачинск, Березовка, Боготол, Бородино, Большая Мурта,
                  Дивногорск, Емельяново, Железногорск, Зеленогорск, Иланский,
                  Казачинское, Канск, Каратузское, Минусинск, Назарово,
                  Новосёлово, Сосновоборск, Уяр, Шарыпово, Шушенское.
                </p>
                <p>
                  Основа репертуара всех коллективов-участников Фестиваля –
                  духовная музыка, патриотические и народные песни, музыка
                  современных композиторов.
                </p>
              </div>

              <VenzelFive />
              <VenzelFive />
              <VenzelFive />
              <VenzelFive />
            </div>

            {!colorThemeRedux && (
              <div className={styles.separator + " " + styles.separator_down} />
            )}
          </section>
        </Container>
      </PageTemplate>
    </>
  );
};

export default History;
